import React from 'react';

import { useCurrentProjectId } from '@adsk/alloy-provider';
import { ShapeMultipleIcon } from '@adsk/alloy-react-icon';
import Theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import useFetchSurface from './useFetchSurface';
import EntityMenuItem from '../../../EntityMenuItem';
import { documentEntityLink } from '../helpers/utils';
import { DocumentEntity } from '../types/types';

const MarkupsEntityMenuItem = ({
  entity,
  ...rest
}: {
  entity: DocumentEntity;
}) => {
  const { id, name, entityId } = entity;
  const projectId = useCurrentProjectId();
  const surface = useFetchSurface(projectId, id);
  const url = projectId && documentEntityLink({ projectId, entityId, surface });

  const label = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span style={{ paddingLeft: 6, color: Theme.colors.charcoal900 }}>
        <OverflowTooltip
          getTargetProps={() => ({ style: { maxWidth: '200px' } })}
          autoTipOnEllipsis
        >
          {name}
        </OverflowTooltip>
      </span>
    </div>
  );

  return (
    <EntityMenuItem
      key={id}
      label={label}
      renderIcon={(p) => <ShapeMultipleIcon {...p} />}
      link={url}
      {...rest}
    />
  );
};

export default MarkupsEntityMenuItem;
